import Select from 'components/commons/select'
import { Button } from 'avo-ui'

export const RightButton = ({ options, selectedValue, onShowModal, onChangeState }) => {
    return (
        <div className={'flex flex-row gap-4'}>
            <Select
                name={'state'}
                className={'w-36'}
                placeholder={'Select Status'}
                options={options.select[selectedValue?.tab]}
                value={selectedValue?.select}
                onChange={(value) => onChangeState(value)}
            />
            <Button
                title={'Apply'}
                onClick={onShowModal}
                disabled={selectedValue?.selectedIds?.length === 0 || !selectedValue?.select.label}
            />
        </div>
    )
}
